"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Settings Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.161
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsApi = exports.SettingsApiFactory = exports.SettingsApiFp = exports.SettingsApiAxiosParamCreator = exports.PaddockTypeEnum = exports.LogLevelEnum = exports.HeadingTestOverrideEnum = exports.HardwarePlatformEnum = exports.DeadReckoningModeEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.DeadReckoningModeEnum = {
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.HardwarePlatformEnum = {
    P4: 'P4',
    P5: 'P5'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.HeadingTestOverrideEnum = {
    NONE: 'HEADING_TEST_OVERRIDE_NONE',
    FORCE_PASS: 'HEADING_TEST_OVERRIDE_FORCE_PASS',
    FORCE_FAIL: 'HEADING_TEST_OVERRIDE_FORCE_FAIL'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.LogLevelEnum = {
    NONE: 'LOG_LEVEL_NONE',
    ERROR: 'LOG_LEVEL_ERROR',
    WARN: 'LOG_LEVEL_WARN',
    INFO: 'LOG_LEVEL_INFO',
    DEBUG: 'LOG_LEVEL_DEBUG',
    VERBOSE: 'LOG_LEVEL_VERBOSE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.PaddockTypeEnum = {
    ALL_TYPES: 'ALL_TYPES',
    PASTURE: 'PASTURE',
    CROP: 'CROP'
};
/**
 * SettingsApi - axios parameter creator
 * @export
 */
var SettingsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Batch update engineering settings
         * @param {IBatchUpdateEngineeringSettingsDTO} [iBatchUpdateEngineeringSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchUpdateDeviceEngineeringSettings: function (iBatchUpdateEngineeringSettingsDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/settings/device/engineering/batch";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iBatchUpdateEngineeringSettingsDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Retrieve engineering settings for a device
         * @param {string} serialNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceEngineeringSettings: function (serialNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('getDeviceEngineeringSettings', 'serialNumber', serialNumber);
                    localVarPath = "/settings/device/{serialNumber}/engineering"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Retrieve serial numbers by engineering settings
         * @param {IEngineeringSettingsDTO} [iEngineeringSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevicesByEngineeringSettings: function (iEngineeringSettingsDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/settings/device/engineering/search";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iEngineeringSettingsDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmEngineeringSettings: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('getFarmEngineeringSettings', 'farmId', farmId);
                    localVarPath = "/settings/farm/{farmId}/engineering"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmLocalisationSettings: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('getFarmLocalisationSettings', 'farmId', farmId);
                    localVarPath = "/settings/farm/{farmId}/operational/localisation"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Retrieves all static metadata for settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetadata: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/settings/metadata";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Retrieves all settings
         * @param {Array<string>} [serialNumbers] List of serialNumbers separated by comma
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings: function (serialNumbers, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/settings";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (serialNumbers) {
                        localVarQueryParameter['serialNumbers'] = serialNumbers;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * This will only update the settings given.
         * @param {string} farmId
         * @param {IEngineeringSettingsDTO} [iEngineeringSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchFarmEngineeringSettings: function (farmId, iEngineeringSettingsDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('patchFarmEngineeringSettings', 'farmId', farmId);
                    localVarPath = "/settings/farm/{farmId}/engineering"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iEngineeringSettingsDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * This will trigger a new setting calcuation for all devices linked to the farm
         * @param {Array<string>} farmIds Comma separated farmIds to have the settings refreshed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshSettingsForFarm: function (farmIds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmIds' is not null or undefined
                    (0, common_1.assertParamExists)('refreshSettingsForFarm', 'farmIds', farmIds);
                    localVarPath = "/settings/refresh";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (farmIds) {
                        localVarQueryParameter['farmIds'] = farmIds;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * This will fully overwrite cowg settings stored for the cattle
         * @param {string} cattleId
         * @param {ICattleCowgSettingsDTO} [iCattleCowgSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCattleCowgSettings: function (cattleId, iCattleCowgSettingsDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'cattleId' is not null or undefined
                    (0, common_1.assertParamExists)('updateCattleCowgSettings', 'cattleId', cattleId);
                    localVarPath = "/settings/cattle/{cattleId}/cowg"
                        .replace("{".concat("cattleId", "}"), encodeURIComponent(String(cattleId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCattleCowgSettingsDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * This will fully overwrite calibration settings stored for the device
         * @param {string} serialNumber
         * @param {ICalibrationSettingsDTO} [iCalibrationSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceCalibrationSettings: function (serialNumber, iCalibrationSettingsDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('updateDeviceCalibrationSettings', 'serialNumber', serialNumber);
                    localVarPath = "/settings/device/{serialNumber}/calibration"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCalibrationSettingsDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * This will fully overwrite engineering settings stored for the device
         * @param {string} serialNumber
         * @param {IEngineeringSettingsDTO} [iEngineeringSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceEngineeringSettings: function (serialNumber, iEngineeringSettingsDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('updateDeviceEngineeringSettings', 'serialNumber', serialNumber);
                    localVarPath = "/settings/device/{serialNumber}/engineering"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iEngineeringSettingsDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * This will fully overwrite experimental settings stored for the device
         * @param {string} serialNumber
         * @param {IExperimentalSettingsDTO} [iExperimentalSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceExperimentalSettings: function (serialNumber, iExperimentalSettingsDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('updateDeviceExperimentalSettings', 'serialNumber', serialNumber);
                    localVarPath = "/settings/device/{serialNumber}/experimental"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iExperimentalSettingsDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * This will fully overwrite firmware update settings stored for the device
         * @param {string} serialNumber
         * @param {IFirmwareUpdateSettingsDTO} [iFirmwareUpdateSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceFirmwareUpdateSettings: function (serialNumber, iFirmwareUpdateSettingsDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('updateDeviceFirmwareUpdateSettings', 'serialNumber', serialNumber);
                    localVarPath = "/settings/device/{serialNumber}/firmware-update"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iFirmwareUpdateSettingsDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * This will fully overwrite Wifi settings (within operational chunk)
         * @param {string} serialNumber
         * @param {IWifiSettingsDTO} [iWifiSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceOperationalWifiSettings: function (serialNumber, iWifiSettingsDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('updateDeviceOperationalWifiSettings', 'serialNumber', serialNumber);
                    localVarPath = "/settings/device/{serialNumber}/operational/wifi"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iWifiSettingsDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * This will fully overwrite cowg settings stored for the farm
         * @param {string} farmId
         * @param {IFarmCowgSettingsDTO} [iFarmCowgSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmCowgSettings: function (farmId, iFarmCowgSettingsDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('updateFarmCowgSettings', 'farmId', farmId);
                    localVarPath = "/settings/farm/{farmId}/cowg"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iFarmCowgSettingsDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Fully overwrite farm localisation settings
         * @param {string} farmId
         * @param {ILocalisationSettingsDTO} [iLocalisationSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmLocalisationSettings: function (farmId, iLocalisationSettingsDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('updateFarmLocalisationSettings', 'farmId', farmId);
                    localVarPath = "/settings/farm/{farmId}/operational/localisation"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iLocalisationSettingsDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.SettingsApiAxiosParamCreator = SettingsApiAxiosParamCreator;
/**
 * SettingsApi - functional programming interface
 * @export
 */
var SettingsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SettingsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Batch update engineering settings
         * @param {IBatchUpdateEngineeringSettingsDTO} [iBatchUpdateEngineeringSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchUpdateDeviceEngineeringSettings: function (iBatchUpdateEngineeringSettingsDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.batchUpdateDeviceEngineeringSettings(iBatchUpdateEngineeringSettingsDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieve engineering settings for a device
         * @param {string} serialNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceEngineeringSettings: function (serialNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDeviceEngineeringSettings(serialNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieve serial numbers by engineering settings
         * @param {IEngineeringSettingsDTO} [iEngineeringSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevicesByEngineeringSettings: function (iEngineeringSettingsDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDevicesByEngineeringSettings(iEngineeringSettingsDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmEngineeringSettings: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFarmEngineeringSettings(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmLocalisationSettings: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFarmLocalisationSettings(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieves all static metadata for settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetadata: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMetadata(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieves all settings
         * @param {Array<string>} [serialNumbers] List of serialNumbers separated by comma
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings: function (serialNumbers, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSettings(serialNumbers, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This will only update the settings given.
         * @param {string} farmId
         * @param {IEngineeringSettingsDTO} [iEngineeringSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchFarmEngineeringSettings: function (farmId, iEngineeringSettingsDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchFarmEngineeringSettings(farmId, iEngineeringSettingsDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This will trigger a new setting calcuation for all devices linked to the farm
         * @param {Array<string>} farmIds Comma separated farmIds to have the settings refreshed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshSettingsForFarm: function (farmIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.refreshSettingsForFarm(farmIds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This will fully overwrite cowg settings stored for the cattle
         * @param {string} cattleId
         * @param {ICattleCowgSettingsDTO} [iCattleCowgSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCattleCowgSettings: function (cattleId, iCattleCowgSettingsDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCattleCowgSettings(cattleId, iCattleCowgSettingsDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This will fully overwrite calibration settings stored for the device
         * @param {string} serialNumber
         * @param {ICalibrationSettingsDTO} [iCalibrationSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceCalibrationSettings: function (serialNumber, iCalibrationSettingsDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDeviceCalibrationSettings(serialNumber, iCalibrationSettingsDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This will fully overwrite engineering settings stored for the device
         * @param {string} serialNumber
         * @param {IEngineeringSettingsDTO} [iEngineeringSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceEngineeringSettings: function (serialNumber, iEngineeringSettingsDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDeviceEngineeringSettings(serialNumber, iEngineeringSettingsDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This will fully overwrite experimental settings stored for the device
         * @param {string} serialNumber
         * @param {IExperimentalSettingsDTO} [iExperimentalSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceExperimentalSettings: function (serialNumber, iExperimentalSettingsDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDeviceExperimentalSettings(serialNumber, iExperimentalSettingsDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This will fully overwrite firmware update settings stored for the device
         * @param {string} serialNumber
         * @param {IFirmwareUpdateSettingsDTO} [iFirmwareUpdateSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceFirmwareUpdateSettings: function (serialNumber, iFirmwareUpdateSettingsDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDeviceFirmwareUpdateSettings(serialNumber, iFirmwareUpdateSettingsDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This will fully overwrite Wifi settings (within operational chunk)
         * @param {string} serialNumber
         * @param {IWifiSettingsDTO} [iWifiSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceOperationalWifiSettings: function (serialNumber, iWifiSettingsDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDeviceOperationalWifiSettings(serialNumber, iWifiSettingsDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This will fully overwrite cowg settings stored for the farm
         * @param {string} farmId
         * @param {IFarmCowgSettingsDTO} [iFarmCowgSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmCowgSettings: function (farmId, iFarmCowgSettingsDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFarmCowgSettings(farmId, iFarmCowgSettingsDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Fully overwrite farm localisation settings
         * @param {string} farmId
         * @param {ILocalisationSettingsDTO} [iLocalisationSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmLocalisationSettings: function (farmId, iLocalisationSettingsDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFarmLocalisationSettings(farmId, iLocalisationSettingsDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SettingsApiFp = SettingsApiFp;
/**
 * SettingsApi - factory interface
 * @export
 */
var SettingsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SettingsApiFp)(configuration);
    return {
        /**
         * Batch update engineering settings
         * @param {IBatchUpdateEngineeringSettingsDTO} [iBatchUpdateEngineeringSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchUpdateDeviceEngineeringSettings: function (iBatchUpdateEngineeringSettingsDTO, options) {
            return localVarFp.batchUpdateDeviceEngineeringSettings(iBatchUpdateEngineeringSettingsDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieve engineering settings for a device
         * @param {string} serialNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceEngineeringSettings: function (serialNumber, options) {
            return localVarFp.getDeviceEngineeringSettings(serialNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieve serial numbers by engineering settings
         * @param {IEngineeringSettingsDTO} [iEngineeringSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevicesByEngineeringSettings: function (iEngineeringSettingsDTO, options) {
            return localVarFp.getDevicesByEngineeringSettings(iEngineeringSettingsDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmEngineeringSettings: function (farmId, options) {
            return localVarFp.getFarmEngineeringSettings(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmLocalisationSettings: function (farmId, options) {
            return localVarFp.getFarmLocalisationSettings(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves all static metadata for settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetadata: function (options) {
            return localVarFp.getMetadata(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves all settings
         * @param {Array<string>} [serialNumbers] List of serialNumbers separated by comma
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings: function (serialNumbers, options) {
            return localVarFp.getSettings(serialNumbers, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This will only update the settings given.
         * @param {string} farmId
         * @param {IEngineeringSettingsDTO} [iEngineeringSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchFarmEngineeringSettings: function (farmId, iEngineeringSettingsDTO, options) {
            return localVarFp.patchFarmEngineeringSettings(farmId, iEngineeringSettingsDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This will trigger a new setting calcuation for all devices linked to the farm
         * @param {Array<string>} farmIds Comma separated farmIds to have the settings refreshed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshSettingsForFarm: function (farmIds, options) {
            return localVarFp.refreshSettingsForFarm(farmIds, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This will fully overwrite cowg settings stored for the cattle
         * @param {string} cattleId
         * @param {ICattleCowgSettingsDTO} [iCattleCowgSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCattleCowgSettings: function (cattleId, iCattleCowgSettingsDTO, options) {
            return localVarFp.updateCattleCowgSettings(cattleId, iCattleCowgSettingsDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This will fully overwrite calibration settings stored for the device
         * @param {string} serialNumber
         * @param {ICalibrationSettingsDTO} [iCalibrationSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceCalibrationSettings: function (serialNumber, iCalibrationSettingsDTO, options) {
            return localVarFp.updateDeviceCalibrationSettings(serialNumber, iCalibrationSettingsDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This will fully overwrite engineering settings stored for the device
         * @param {string} serialNumber
         * @param {IEngineeringSettingsDTO} [iEngineeringSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceEngineeringSettings: function (serialNumber, iEngineeringSettingsDTO, options) {
            return localVarFp.updateDeviceEngineeringSettings(serialNumber, iEngineeringSettingsDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This will fully overwrite experimental settings stored for the device
         * @param {string} serialNumber
         * @param {IExperimentalSettingsDTO} [iExperimentalSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceExperimentalSettings: function (serialNumber, iExperimentalSettingsDTO, options) {
            return localVarFp.updateDeviceExperimentalSettings(serialNumber, iExperimentalSettingsDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This will fully overwrite firmware update settings stored for the device
         * @param {string} serialNumber
         * @param {IFirmwareUpdateSettingsDTO} [iFirmwareUpdateSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceFirmwareUpdateSettings: function (serialNumber, iFirmwareUpdateSettingsDTO, options) {
            return localVarFp.updateDeviceFirmwareUpdateSettings(serialNumber, iFirmwareUpdateSettingsDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This will fully overwrite Wifi settings (within operational chunk)
         * @param {string} serialNumber
         * @param {IWifiSettingsDTO} [iWifiSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceOperationalWifiSettings: function (serialNumber, iWifiSettingsDTO, options) {
            return localVarFp.updateDeviceOperationalWifiSettings(serialNumber, iWifiSettingsDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This will fully overwrite cowg settings stored for the farm
         * @param {string} farmId
         * @param {IFarmCowgSettingsDTO} [iFarmCowgSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmCowgSettings: function (farmId, iFarmCowgSettingsDTO, options) {
            return localVarFp.updateFarmCowgSettings(farmId, iFarmCowgSettingsDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Fully overwrite farm localisation settings
         * @param {string} farmId
         * @param {ILocalisationSettingsDTO} [iLocalisationSettingsDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmLocalisationSettings: function (farmId, iLocalisationSettingsDTO, options) {
            return localVarFp.updateFarmLocalisationSettings(farmId, iLocalisationSettingsDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SettingsApiFactory = SettingsApiFactory;
/**
 * SettingsApi - object-oriented interface
 * @export
 * @class SettingsApi
 * @extends {BaseAPI}
 */
var SettingsApi = /** @class */ (function (_super) {
    __extends(SettingsApi, _super);
    function SettingsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Batch update engineering settings
     * @param {IBatchUpdateEngineeringSettingsDTO} [iBatchUpdateEngineeringSettingsDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    SettingsApi.prototype.batchUpdateDeviceEngineeringSettings = function (iBatchUpdateEngineeringSettingsDTO, options) {
        var _this = this;
        return (0, exports.SettingsApiFp)(this.configuration).batchUpdateDeviceEngineeringSettings(iBatchUpdateEngineeringSettingsDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieve engineering settings for a device
     * @param {string} serialNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    SettingsApi.prototype.getDeviceEngineeringSettings = function (serialNumber, options) {
        var _this = this;
        return (0, exports.SettingsApiFp)(this.configuration).getDeviceEngineeringSettings(serialNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieve serial numbers by engineering settings
     * @param {IEngineeringSettingsDTO} [iEngineeringSettingsDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    SettingsApi.prototype.getDevicesByEngineeringSettings = function (iEngineeringSettingsDTO, options) {
        var _this = this;
        return (0, exports.SettingsApiFp)(this.configuration).getDevicesByEngineeringSettings(iEngineeringSettingsDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} farmId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    SettingsApi.prototype.getFarmEngineeringSettings = function (farmId, options) {
        var _this = this;
        return (0, exports.SettingsApiFp)(this.configuration).getFarmEngineeringSettings(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} farmId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    SettingsApi.prototype.getFarmLocalisationSettings = function (farmId, options) {
        var _this = this;
        return (0, exports.SettingsApiFp)(this.configuration).getFarmLocalisationSettings(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves all static metadata for settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    SettingsApi.prototype.getMetadata = function (options) {
        var _this = this;
        return (0, exports.SettingsApiFp)(this.configuration).getMetadata(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves all settings
     * @param {Array<string>} [serialNumbers] List of serialNumbers separated by comma
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    SettingsApi.prototype.getSettings = function (serialNumbers, options) {
        var _this = this;
        return (0, exports.SettingsApiFp)(this.configuration).getSettings(serialNumbers, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This will only update the settings given.
     * @param {string} farmId
     * @param {IEngineeringSettingsDTO} [iEngineeringSettingsDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    SettingsApi.prototype.patchFarmEngineeringSettings = function (farmId, iEngineeringSettingsDTO, options) {
        var _this = this;
        return (0, exports.SettingsApiFp)(this.configuration).patchFarmEngineeringSettings(farmId, iEngineeringSettingsDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This will trigger a new setting calcuation for all devices linked to the farm
     * @param {Array<string>} farmIds Comma separated farmIds to have the settings refreshed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    SettingsApi.prototype.refreshSettingsForFarm = function (farmIds, options) {
        var _this = this;
        return (0, exports.SettingsApiFp)(this.configuration).refreshSettingsForFarm(farmIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This will fully overwrite cowg settings stored for the cattle
     * @param {string} cattleId
     * @param {ICattleCowgSettingsDTO} [iCattleCowgSettingsDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    SettingsApi.prototype.updateCattleCowgSettings = function (cattleId, iCattleCowgSettingsDTO, options) {
        var _this = this;
        return (0, exports.SettingsApiFp)(this.configuration).updateCattleCowgSettings(cattleId, iCattleCowgSettingsDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This will fully overwrite calibration settings stored for the device
     * @param {string} serialNumber
     * @param {ICalibrationSettingsDTO} [iCalibrationSettingsDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    SettingsApi.prototype.updateDeviceCalibrationSettings = function (serialNumber, iCalibrationSettingsDTO, options) {
        var _this = this;
        return (0, exports.SettingsApiFp)(this.configuration).updateDeviceCalibrationSettings(serialNumber, iCalibrationSettingsDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This will fully overwrite engineering settings stored for the device
     * @param {string} serialNumber
     * @param {IEngineeringSettingsDTO} [iEngineeringSettingsDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    SettingsApi.prototype.updateDeviceEngineeringSettings = function (serialNumber, iEngineeringSettingsDTO, options) {
        var _this = this;
        return (0, exports.SettingsApiFp)(this.configuration).updateDeviceEngineeringSettings(serialNumber, iEngineeringSettingsDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This will fully overwrite experimental settings stored for the device
     * @param {string} serialNumber
     * @param {IExperimentalSettingsDTO} [iExperimentalSettingsDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    SettingsApi.prototype.updateDeviceExperimentalSettings = function (serialNumber, iExperimentalSettingsDTO, options) {
        var _this = this;
        return (0, exports.SettingsApiFp)(this.configuration).updateDeviceExperimentalSettings(serialNumber, iExperimentalSettingsDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This will fully overwrite firmware update settings stored for the device
     * @param {string} serialNumber
     * @param {IFirmwareUpdateSettingsDTO} [iFirmwareUpdateSettingsDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    SettingsApi.prototype.updateDeviceFirmwareUpdateSettings = function (serialNumber, iFirmwareUpdateSettingsDTO, options) {
        var _this = this;
        return (0, exports.SettingsApiFp)(this.configuration).updateDeviceFirmwareUpdateSettings(serialNumber, iFirmwareUpdateSettingsDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This will fully overwrite Wifi settings (within operational chunk)
     * @param {string} serialNumber
     * @param {IWifiSettingsDTO} [iWifiSettingsDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    SettingsApi.prototype.updateDeviceOperationalWifiSettings = function (serialNumber, iWifiSettingsDTO, options) {
        var _this = this;
        return (0, exports.SettingsApiFp)(this.configuration).updateDeviceOperationalWifiSettings(serialNumber, iWifiSettingsDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This will fully overwrite cowg settings stored for the farm
     * @param {string} farmId
     * @param {IFarmCowgSettingsDTO} [iFarmCowgSettingsDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    SettingsApi.prototype.updateFarmCowgSettings = function (farmId, iFarmCowgSettingsDTO, options) {
        var _this = this;
        return (0, exports.SettingsApiFp)(this.configuration).updateFarmCowgSettings(farmId, iFarmCowgSettingsDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Fully overwrite farm localisation settings
     * @param {string} farmId
     * @param {ILocalisationSettingsDTO} [iLocalisationSettingsDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    SettingsApi.prototype.updateFarmLocalisationSettings = function (farmId, iLocalisationSettingsDTO, options) {
        var _this = this;
        return (0, exports.SettingsApiFp)(this.configuration).updateFarmLocalisationSettings(farmId, iLocalisationSettingsDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SettingsApi;
}(base_1.BaseAPI));
exports.SettingsApi = SettingsApi;
